import React, {Component} from 'react'
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap"
import {ReactComponent as IconReport} from "../../../assets/icon/operation-report.svg"
import {Button, DatePicker, message, Select} from 'antd'
import moment from "moment"
import store from 'store'
import {listErrorProcessQuality, listErrorCustomerService} from '../../helpers/filtersTable'
import ChartReport from './ChartReport'
import TableReport from './TableReport'
import downloadFile from '../../../share/downloadFile'
import { getStatisticCustomerService, getStatisticProcessQuality, getStatisticProductResult } from '../../../services/api/apiOrdersReport'
import calculateRatio from '../../helpers/calculateRatio'

const {RangePicker} = DatePicker
const { Option } = Select

class OperationsReportContainer extends Component {
    state = {
        loading: false, 
        error: '',
        typeReport: 'product_results',
        typeError: 'all',
        // selectedDate: [moment().startOf('date'), moment()],
        selectedDate: [moment().subtract(7, 'weeks'), moment()],
        payload: {
            date_from: moment().subtract(7, 'weeks').format('DD/MM/YYYY'),
            date_to: moment().format('DD/MM/YYYY'),
        },
        periodType: '1W',
        data: [],
        downloading: false,
    }

    componentDidMount() {
        const wrapper = document.getElementsByClassName('content-wrapper')[0]
        wrapper && wrapper.classList.add('OperationsReport')

        // const dateFilter = store.get('dateFilter')

        // if (dateFilter) {
        //     this.setState({
        //         selectedDate: [moment(dateFilter.date_from, 'DD/MM/YYYY'), moment(dateFilter.date_to, 'DD/MM/YYYY')],
        //         payload: {
        //             date_from: dateFilter.date_from,
        //             date_to: dateFilter.date_to,
        //         },
        //     }, () => {
        //         this._fetchOperationsReport()
        //     })
        // } else {
        //     this._fetchOperationsReport()
        // }

        this._fetchOperationsReport()
    }

    handleChangeSelect = (field, value) => {
        if(field === 'typeReport'){
            if(value === 'customer_service'){
                this.setState({
                    [field]: value,
                    selectedDate: [moment().subtract(6, 'months'), moment()],
                    payload: {
                        date_from: moment().subtract(6, 'months').format('DD/MM/YYYY'),
                        date_to: moment().format('DD/MM/YYYY'),
                    },
                    periodType: '1M'
                }, () => {
                    this._fetchOperationsReport()
                })
            }else{
                this.setState({
                    [field]: value,
                    selectedDate: [moment().subtract(7, 'weeks'), moment()],
                    payload: {
                        date_from: moment().subtract(7, 'weeks').format('DD/MM/YYYY'),
                        date_to: moment().format('DD/MM/YYYY'),
                    },
                }, () => {
                    this._fetchOperationsReport()
                })
            }
        }else{
            this.setState({
                [field]: value
            }, () => {
                this._fetchOperationsReport()
            })
        }
    }

    _onChange = (dates) => {
        const {typeReport} = this.state

        if (!!dates && dates.length === 2) {
            const date_from = moment(dates[0]).format('DD/MM/YYYY')
            const date_to = moment(dates[1]).format('DD/MM/YYYY')

            this.setState({
                payload: {
                    date_from,
                    date_to,
                },
            }, () => {
                this.setState({
                    selectedDate: dates,
                })
                // store.set('dateFilter', {date_from, date_to})
                this._fetchOperationsReport()
            })
        }else{
            if(typeReport === 'customer_service'){
                this.setState({
                    selectedDate: [moment().subtract(6, 'months'), moment()],
                    payload: {
                        date_from: moment().subtract(6, 'months').format('DD/MM/YYYY'),
                        date_to: moment().format('DD/MM/YYYY'),
                    }
                }, () => {
                    this._fetchOperationsReport()
                })
            }else{
                this.setState({
                    selectedDate: [moment().subtract(7, 'weeks'), moment()],
                    payload: {
                        date_from: moment().subtract(7, 'weeks').format('DD/MM/YYYY'),
                        date_to: moment().format('DD/MM/YYYY'),
                    },
                }, () => {
                    this._fetchOperationsReport()
                })
            }

            // this._fetchOperationsReport()
        }
    }

    convertDateFormat = (dateStr) => {
        const [day, month, year] = dateStr.split('/');
        return `${year}-${month}-${day}`;
    };

    getQuarterFromRange = (startDate, endDate) => {
        const start = moment(startDate);
        const end = moment(endDate);

        // Kiểm tra cùng năm và cùng quý
        if (start.year() !== end.year()) return 'Không cùng năm';
        // if (start.quarter() !== end.quarter()) return 'Không cùng quý';

        return `${start.year()}-Q${start.quarter()}`;
    }

    _fetchOperationsReport = async () => {
        this.setState({
            loading: true,
            error: '',
        })

        try {
            const {typeReport, periodType, payload, typeError} = this.state

            let response = null;
            switch (typeReport) {
                case 'product_results':
                    const ProductResultParams = `from=${this.convertDateFormat(payload.date_from)}&to=${this.convertDateFormat(payload.date_to)}&periodType=${periodType}`
                    const responseProductResults = await getStatisticProductResult(ProductResultParams);
                    response = responseProductResults.data
                    break;
                case 'process_quality':
                    const ProcessQualityPayload = {
                        date: {
                            from: this.convertDateFormat(payload.date_from),
                            to: this.convertDateFormat(payload.date_to),
                            period: periodType === '1D' ? 'daily' : periodType === '1M' ? 'monthly' : periodType === '1Q' ? 'quarterly' : periodType === '1Y' ? 'yearly' : "weekly"
                        },
                        error_type: typeError !== 'all' ? typeError : '',
                        fill_empty_periods: true
                    }
                    const responseProcessQuality = await getStatisticProcessQuality(ProcessQualityPayload);
                    response = responseProcessQuality.data
                    break;
                case 'customer_service':
                    const CustomerServiceParams = `from=${this.convertDateFormat(payload.date_from)}&to=${this.convertDateFormat(payload.date_to)}&error=${typeError}`
                    const responseCustomerService = await getStatisticCustomerService(CustomerServiceParams);
                    response = responseCustomerService.data
                    break;
                default:
                    throw new Error("Unknown report type");
            }

            const {data, success, message} = response

            if (!success) {
                return this.setState({
                    data: [],
                    loading: null,
                    error: message,
                })
            }

            let dataReport = []
            
            switch (typeReport) {
                case 'product_results':
                    dataReport = data.map(itemData => {
                        const itemRow = {
                            periodKey: itemData.periodKey,
                            totalX: itemData.totalItemPackaged,
                            totalY: itemData.totalItemCreated,
                        }

                        return itemRow
                    })
                    
                    break;
                case 'process_quality':
                    const {total_error_items, total_packaged_items, total, items} = data
                    dataReport = items.sort((a, b) => new Date(a.date) - new Date(b.date)).map(item => {

                        const itemRow = {
                            periodKey: periodType === '1Y' ? moment(item.date).format('YYYY') : periodType === '1Q' ? this.getQuarterFromRange(item.date, item.date_end) : moment(item.date).format('YYYY-MM-DD'),
                            totalX: item.error_items,
                            totalY: item.packaged_items,
                        }

                        return itemRow
                    })
                    
                    break;
                case 'customer_service':
                    dataReport = data.map(itemData => {
                        const itemRow = {
                            periodKey: itemData.periodKey,
                            totalX: itemData.total,
                            totalY: itemData.totalItemPackaged,
                        }

                        return itemRow
                    })    

                    break;
                default:
                    throw new Error("Unknown report type");
            }

            this.setState({
                loading: false,
                data: dataReport,
                // data: monthDataFake
            })
        } catch (e) {
            this.setState({
                loading: null,
                error: e.message,
            })
        }
    }

    _genDataLabels = () => {
        const {
            periodType,
            data
        } = this.state
        
        return data.map(item => {
            if(periodType === '1D'){
                return moment(item.periodKey, "YYYY-MM-DD").format("DD/MM/YYYY");
            }else if(periodType === '1W'){
                const startDate = moment(item.periodKey, "YYYY-MM-DD");
                const endDate = startDate.clone().add(6, 'days');

                return `${startDate.format("DD/MM/YYYY")} - ${endDate.format("DD/MM/YYYY")}`;
            }else if(periodType === '1M'){
                return moment(item.periodKey, "YYYY-MM").format("MM/YYYY");
            }else if(periodType === '1Q'){

                const [year, quarter] = item.periodKey.split('-');
                const quarterNumber = quarter ? quarter.replace('Q', '0') : '';
                return `Quý ${quarterNumber}/${year}`
            }else{
                return item.periodKey
            }
        })
    }

    _exportReport = async () => {
        try {
            this.setState({ downloading: true })
            const { data, typeReport } = this.state
            const sortKey = this._genDataLabels()
            const dataDownload = []
            
            const dataRow1 = data.reduce((acc, item, index) => {
                acc[sortKey[index]] = item.totalX;
                return acc;
            }, {});

            const dataRow1Title = {
                '': typeReport === 'customer_service' ? 'Tổng số lượng item bị claim lỗi' : typeReport === 'process_quality' ? 'Tổng số lượng item lỗi' : 'Tổng số lượng item được đóng thùng',
                ...dataRow1
            }

            dataDownload.push(dataRow1Title)

            const dataRow2 = data.reduce((acc, item, index) => {
                acc[sortKey[index]] = item.totalY;
                return acc;
            }, {});

            const dataRow2Title = {
                '': typeReport === 'customer_service' ? 'Tổng số lượng item được đóng thùng' : typeReport === 'process_quality' ? 'Tổng số item được đóng thùng trong khoảng thời gian đó' : 'Tổng số lượng item đẩy xưởng',
                ...dataRow2
            }

            dataDownload.push(dataRow2Title)

            const dataRow3 = data.reduce((acc, item, index) => {
                acc[sortKey[index]] = `${calculateRatio(item.totalX, item.totalY)}%`;
                return acc;
            }, {});

            const dataRow3Title = {
                '': typeReport === 'customer_service' ? 'Tỉ lệ bị claim ' : typeReport === 'process_quality' ? 'Tỉ lệ lỗi' : 'Tỉ lệ sản xuất',
                ...dataRow3
            }

            dataDownload.push(dataRow3Title)

            downloadFile(dataDownload, {
                filePrefix: typeReport === 'customer_service' ? 'Customer-service-report' : typeReport === 'process_quality' ? 'Process-quality-report' : 'Product-result-report-',
            })
            this.setState({ downloading: false })
        } catch (e) {
            message.error(e.message)
            this.setState({
                error: e.message,
                downloading: false,
            })
        }
    }
    
    render() {
        const {
            loading,
            typeReport,
            typeError,
            periodType,
            selectedDate,
            data,
            downloading
        } = this.state
        
        const message = (() => {
            return (!data || !data.length) && !loading
                ? 'No data'
                : (loading && 'Loading...')
        })()

        const listOption = typeReport === 'process_quality' ? listErrorProcessQuality : typeReport === 'customer_service' ? listErrorCustomerService : []

        const dataLabels = this._genDataLabels()

        return (
            <Row data-key={this.state.time}>
                <Col md={12}>
                    <div className="OperationReportPage">
                        <Card>
                            <CardHeader className="CardHeader text-white header-elements-inline">
                                <h2 className="card-title d-flex align-items-center">
                                    <IconReport width={30}/>
                                    Báo Cáo Vận Hành
                                </h2>
                            </CardHeader>
                            <CardBody>
                                <div className="OperationReportFilter d-flex justify-content-between align-items-center">
                                    <div className='FilterLeft d-flex align-items-center'>
                                        <div className="SelectTypeReport mr-3">
                                            <label className='d-block'>Loại Báo Cáo</label>
                                            <div className="SelectType">
                                                <Select
                                                    value={typeReport || ''}
                                                    style={{ width: 230 }}
                                                    onChange={e => this.handleChangeSelect('typeReport', e)}
                                                    options={[
                                                        { value: 'product_results', label: 'Báo Cáo Kết Quả Sản Xuất' },
                                                        { value: 'process_quality', label: 'Báo Cáo Chất Lượng Công Đoạn' },
                                                        { value: 'customer_service', label: 'Báo Cáo Dịch Vụ Khách Hàng' }
                                                    ]}
                                                />
                                            </div>
                                        </div>

                                        {
                                            (typeReport === 'process_quality' || typeReport === 'customer_service') &&
                                            <div className="SelectTypeReport mr-3">
                                                <label className='d-block'>Loại lỗi</label>
                                                <div className="SelectType">
                                                    <Select
                                                        value={typeError || ''}
                                                        style={{ width: 150 }}
                                                        onChange={e => this.handleChangeSelect('typeError', e)}
                                                    >
                                                        {!!listOption.length && listOption.map(i=>(
                                                            <Option value={i.value} key={i.value}>{i.name}</Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                        }

                                        <div className="SearchDateTime mr-3">
                                            <label className='d-block'>Thời gian</label>
                                            <div className="DatePicker">
                                                <RangePicker
                                                    value={selectedDate}
                                                    // showTime={{format: 'HH:mm'}}
                                                    format="DD/MM/YYYY"
                                                    onChange={this._onChange}
                                                    style={{width: 250}}
                                                />
                                            </div>
                                        </div>

                                        <div className='reloadReport' style={{marginTop: 28}}>
                                            <i className={['BtnRefresh fa fa-refresh', loading && 'disabled spinner'].filter(Boolean).join(' ')}
                                            onClick={this._fetchOperationsReport} title={'Tải lại'}/>
                                        </div>
                                    </div>
                                    <div className='FilterRight d-flex align-items-center' style={{marginTop: 28}}>
                                        {
                                            typeReport !== 'customer_service' &&
                                            <div className="SelectTypeReport mr-3">
                                                <Select
                                                    // defaultValue="lucy"
                                                    value={periodType || ''}
                                                    style={{ width: 70 }}
                                                    onChange={e => this.handleChangeSelect('periodType', e)}
                                                    options={[
                                                        { value: '1D', label: '1D' },
                                                        { value: '1W', label: '1W' },
                                                        { value: '1M', label: '1M' },
                                                        { value: '1Q', label: '1Q' },
                                                        { value: '1Y', label: '1Y' },
                                                    ]}
                                                />
                                            </div>
                                        }

                                        <div className="ExportReport mr-3">
                                            <Button type="default" disabled={downloading}
                                                onClick={this._exportReport}>
                                                {
                                                    downloading && <i className="icon-spinner2 spinner mr-2" />
                                                }
                                                Export
                                            </Button>
                                        </div>
                                    </div>
                                </div>

                                <div className='ReportPageContainer'>
                                    {
                                        message && <p>{message}</p>
                                    }
                                    {
                                        !message &&
                                        <>
                                        <ChartReport data={data} dataLabels={dataLabels} typeReport={typeReport} periodType={periodType}/>
                                        <TableReport data={data} dataLabels={dataLabels} typeReport={typeReport} periodType={periodType}/>
                                        </>
                                    }
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </Col>
            </Row>
        )
    }
}

export default OperationsReportContainer
